module.exports = __webpack_public_path__ + "img/por-dont.eda1753f.png";